import { render } from "./VestingDatatable.vue?vue&type=template&id=1ec2c3bb"
import script from "./VestingDatatable.vue?vue&type=script&lang=ts"
export * from "./VestingDatatable.vue?vue&type=script&lang=ts"
script.render = render

export default script